export default __webpack_public_path__ + "static/media/jelil.90985b2e.webp";